<template>
  <v-data-table :items="shipments" :loading="loading" :headers="headers" :search="search">
    <template v-slot:item.name="{ item }">
      <v-btn
        :to="{ name: 'ShippingSummary', params: { id: parseInt(item.id) } }"
        color="primary"
        rounded
        outlined
        small
      >
        <v-icon left small>mdi-cube-send</v-icon>
        {{ item.name }}
      </v-btn>
    </template>
    <template v-slot:item.id="{ item }">
      <ShippingForm :is-edit="true" :instance="item" :userLoading="userLoading" />
    </template>
    <template v-slot:item.state="{ item }">
      <v-chip v-if="item.state === 'Requested'" color="amber darken-2" dark small>
        <v-icon left small>mdi-basket-fill</v-icon>
        {{ item.state }}
      </v-chip>
      <v-chip v-else-if="item.state === 'Shipped'" color="green darken-2" dark small>
        <v-icon left small>mdi-truck-delivery</v-icon>
        {{ item.state }}
      </v-chip>
      <v-chip v-else color="blue-grey darken-2" dark small>
        <v-icon left small>mdi-check-all</v-icon>
        {{ item.state }}
      </v-chip>
    </template>
    <template v-slot:item.children="{ item }">
      <v-badge>
        <template v-slot:badge>
          {{ item.children.length }}
        </template>
        <v-icon>fas fa-cube</v-icon>
      </v-badge>
    </template>
    <template v-slot:item.customer="{ item }">
      <v-icon v-if="item.customer">
        mdi-cash-refund
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import ShippingForm from "./ShippingForm";
export default {
  name: "ShippingTable",
  components: { ShippingForm },
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: true
    },
    userLoading: {
      type: Boolean,
      required: true,
      default: true
    },
    shipments: {
      type: Array,
      required: true,
      default: () => []
    },
    search: {
      type: String,
      required: true,
      default: ""
    }
  },
  data() {
    return {
      headers: [
        { text: "Name", sortable: true, value: "name" },
        { text: "Status", align: "left", sortable: true, value: "state" },
        { text: "To", sortable: true, value: "shipto" },
        { text: "Tracking #", sortable: true, value: "tracking" },
        { text: "Items", sortable: true, value: "children" },
        { text: "Customer Funded", sortable: true, value: "customer" },
        { text: "Edit", sortable: false, align: "right", value: "id" }
      ]
    };
  }
};
</script>
